export const RECEPTION_STATUS = {
  UNKNOWN: 0,
  BEFORE_RECRUITING: 1,
  RECRUITING: 2,
  CLOSED: 3,
  NOT_CLOSED: 4,
};

export const RECEPTION_STATUS_TEXT = {
  UNKNOWN: '不明',
  BEFORE_RECRUITING: '受付開始前',
  RECRUITING: '受付中',
  CLOSED: '受付終了',
  NOT_CLOSED: '受付未終了（非表示）',
};

export const RECEPTION_STATUS_LABEL = {
  [RECEPTION_STATUS_TEXT.BEFORE_RECRUITING]: '受付開始前です',
  [RECEPTION_STATUS_TEXT.RECRUITING]: 'お申込みはこちら',
  [RECEPTION_STATUS_TEXT.CLOSED]: '受付は終了しました',
  [RECEPTION_STATUS_TEXT.NOT_CLOSED]: '受付未終了（非表示）',
};
